
interface ObjectWrapperProps {
  children: any;
}

export default function ObjectWrapper({ children }: ObjectWrapperProps) {
  return <div>{children}</div>;
}
